module.exports = __webpack_public_path__ + "static/media/shieldGreen.pictogram.c285790f.svg";